import { FC } from "react";

import { IProductionStateLogData } from "@ryde/shared";

interface IProductionLogsStatsTabsMetricsVersions {
  state?: IProductionStateLogData;
}

export const ProductionLogsStatsTabsMetricsVersions: FC<
  IProductionLogsStatsTabsMetricsVersions
> = ({ state }) => {
  const frontendVersion = state?.frontendVersion;
  const backendVersion = state?.backendVersion || state?.apiVersion;

  if (!frontendVersion && !backendVersion) {
    return null;
  }

  return (
    <div className="log__metrics-section">
      <div className="log__metrics-section-title">Versions</div>
      <div className="log__metrics-map-stats">
        {frontendVersion && (
          <div className="log__metrics-map-item">
            <span className="log__metrics-map-label">Frontend version:</span>
            <span className="log__metrics-map-value">{frontendVersion}</span>
          </div>
        )}
        {backendVersion && (
          <div className="log__metrics-map-item">
            <span className="log__metrics-map-label">Backend version:</span>
            <span className="log__metrics-map-value">{backendVersion}</span>
          </div>
        )}
      </div>
    </div>
  );
};
